import { useEffect } from 'react';
import { useDispatch, useSelector } from 'shared/hooks';
import { Heading, LabelText } from 'shared/components';
import { InputsContainer } from 'shared/containers';
import { SplitDate, CurrencyInput, Income } from 'shared/inputs';
import { SwitchCoverageType } from './';
import { sync, SYNC } from 'shared/wizard/actions';
import analytics from 'shared/utility/analytics';
import { premiumPaymentScheme } from '../config';

const ExistingOrv = () => {
  const dispatch = useDispatch();
  const { input, output: { errors } } = useSelector(state => state);

  useEffect(() => {
    dispatch({ type: SYNC, syncing: false });
    analytics.send('Navigeer', 'Existing ORV pagina');
  }, []);

  return (
    <>
      <Heading>Je huidige dekking</Heading>
      <InputsContainer>
        <LabelText>Huidige premie</LabelText>
        <Income
          name="premium"
          amount={input.premium}
          period={input.payment}
          periodOptions={premiumPaymentScheme}
          errors={errors.premium}
          onPeriodChangeHandler={period => sync(dispatch)('payment', period.value)}
          onAmountChangeHandler={sync(dispatch)('premium')}
        />
        <LabelText>Einddatum verzekering</LabelText>
        <SplitDate
          name="endDate"
          onChange={date => sync(dispatch)('endDate', date)}
          value={input.endDate}
          errors={errors.endDate}
        />
        <LabelText>Huidig verzekerd bedrag bij overlijden</LabelText>
        <CurrencyInput
          name="coverage"
          placeholder="Bedrag"
          value={input.coverage}
          errors={errors.coverage}
          onChange={sync(dispatch)('coverage')}
        />
        <LabelText>Type dekking</LabelText>
        <SwitchCoverageType />
      </InputsContainer>
    </>
  );
};

export default ExistingOrv;
